import React from 'react';
// import { Link } from 'react-router-dom';
// import Banner from '../components/Banner';
import './Home.css'; // Import styles
import Carousel from '../components/Carousel';
import Separator from '../components/Separator';
import CompetitionCardContainer from '../components/CompetitionCardContainer';
import Mazar from '../components/Mazar';
import Slideshow from '../components/Slideshow';


const Home = () => {
    return (
        <div>
            <div className='home-container'>
                <Carousel />
                <Separator title={"از حاج قاسم بگو"} />
                {/* <Link to='/form' className='big-button'>شرکت در فراخوان </Link> */}
                <CompetitionCardContainer />
                {/* <div className="post-card-container">
                    <div className="post-card">
                        <div className='post-card-image'></div>
                        <h3>موضوع 1</h3>
                        <p>توضیح کوتاهی در مورد پست</p>
                        <Link to="/blog">بیشتر</Link>
                    </div>
                    <div className="post-card">
                        <div className='post-card-image'></div>
                        <h3>موضوع 2</h3>
                        <p>توضیح کوتاهی در مورد پست</p>
                        <Link to="/blog">بیشتر</Link>
                    </div>
                    <div className="post-card">
                        <div className='post-card-image'></div>
                        <h3>موضوع 3</h3>
                        <p>توضیح کوتاهی در مورد پست</p>
                        <Link to="/blog">بیشتر</Link>
                    </div>
                    Add more post cards as needed
                </div> */}
                <Separator title={"زیارت مزار"} />
                <Mazar />
                <Separator title={"حاج قاسم در خوزستان"} />
                <Slideshow />
            </div>
        </div>
    );
};

export default Home;
